import styled from 'styled-components';

import { getColor } from './getColor';

import type { BriefColorVariants } from './types';

interface Props {
  fill: BriefColorVariants;
}

export const Filler = styled('div')<Props>`
  > svg {
    fill: ${({ fill, theme }) => getColor(fill, theme)};
    width: 24px;
    height: 24px;
  }
`;
